module.exports = __webpack_public_path__ + "static/stable-income-71927f77ed34e16c3116feb852eb2a7a.png";